import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	let obj = {
		searchlist: [{
			prop: "batchNo",
			label: '导入批次号',
			type: "input",
		}, {
			prop: "status",
			label: '批次状态',
			type: "select",
			selectval: comMapping.$scrwlx
		}],
		searchdata: {
			batchNo: '',
			status: '',
		},
		headData: [{
				title: "导入批次号",
				prop: "batchNo",
				width: "150",
				issort: true,
			}, {
				title: "任务类型",
				prop: "subType",
				width: "150",
				custom: true,
				issort: true,
			},
			{
				title: "批次状态",
				prop: "status",
				width: "150",
				custom: true,
				issort: true,
			},
			{
				title: "文件名",
				prop: "fileName",
				width: "150",
				issort: true,
			},
			{
				title: "开始时间",
				prop: "createTime",
				width: "150",
				issort: true,
			},
			{
				title: "结束时间",
				prop: "updateTime",
				width: "150",
				issort: true,
			},
			{
				title: "操作人",
				prop: "creator",
				width: "150",
				issort: true,
			},
			{
				title: "操作",
				prop: "cz",
				width: "250",
				fixed: "right",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
